import {useState,useEffect} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import Modal from 'react-bootstrap/Modal'
import {
	selectMerchandiseById,
	selectShowCheckout,
	setShowCheckout,
	insertNewOrder,
	clearCart,
} from '../slice'
import {CardElement} from '@stripe/react-stripe-js'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import InputGroup from 'react-bootstrap/InputGroup'
import Form from 'react-bootstrap/Form'
import {selectAcceptedCurrency} from '../../settings/settingsSlice'
import {envAwarePost} from '../../../util/util'
import {useCart} from '../hooks'

const getPaymentIntent = (items)=>(
	envAwarePost(
		'api/merchandise/',
		{action:'getPaymentIntent',items}
	)
)

const confirmCardPayment = (stripe,client_secret,card)=>(
	stripe.confirmCardPayment(
		client_secret,
		{payment_method: {card}}
	)
)

const finalizePaymentIntent = (payment_intent_id) => envAwarePost(
	'api/merchandise/',
	{action:'finalizePaymentIntent',payment_intent_id}
)

const PurchaseModal = ({stripe,elements})=>{
	const dispatch = useDispatch()

	const onHide = ()=>{
		dispatch(setShowCheckout(false))
		dispatch(clearCart())
	}

	const [status,setStatus] = useState('idle')
	const acceptedCurrency = useSelector(selectAcceptedCurrency)
	const show = useSelector(selectShowCheckout)

	const {total,hasItems,itemsQtyMap} = useCart()

	const handleCheckout = async event =>{
		setStatus('pending')
		// Block native form submission.
		event.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js has not loaded yet. Make sure to disable
			// form submission until Stripe.js has loaded.
			return;
		}

		// Get a reference to a mounted CardElement. Elements knows how
		// to find your CardElement because there can only ever be one of
		// each type of element.
		const card = elements.getElement(CardElement);

		const {error, paymentMethod} = await stripe.createPaymentMethod({
			type: 'card',card
		});
		if (error) {
			console.log('[error]', error);
			setStatus('idle')
		} else {
			const items = Object.entries(itemsQtyMap).map(([id,qty])=>({id,qty}))
			getPaymentIntent(items).then( res => {
				if( res.success != 1 ) throw new Error(res.message)
				const {client_secret} = res.data
				return confirmCardPayment(stripe,client_secret,card)
			}).then( res => {
				if(res.error) throw new Error(res.error.message)
				if(res.paymentIntent.status !== 'succeeded') throw new Error("Something went wrong. Please, try again")
				return finalizePaymentIntent(res.paymentIntent.id)
			}).then( res => {
				if( res.success === '1' ){
					window.alert('Your order has been successfully placed. Check the orders tab.')
					return dispatch(insertNewOrder(res.data.order))
				}else{
					throw new Error(res.message)
				}
			}).then( res => {
				card.clear()
				onHide()
				setStatus('idle')
			}).catch( err => {
				setStatus('idle')
				window.alert(err)
			})
		}
	}

	if(!hasItems) return null
	return (
		<Modal 
			onHide={onHide}
			show={show}
			centered
		>
			<Modal.Header>
				Checkout
			</Modal.Header>
			<Modal.Body>
				<div className="border border-dark p-2 rounded mt-2">
					<CardElement
						options={{
							hidePostalCode:true,
							style: {
								base: {
									fontSize: '16px',
									color: '#424770',
									'::placeholder': {
										color: '#aab7c4',
									},
								},
								invalid: {
									color: '#9e2146',
								},
							},
						}}
					/>
				</div>
				<div className="text-right mt-2">
					<Button 
						disabled={status==='pending'}
						onClick={handleCheckout} 
						variant="outline-success" 
						size="sm"
					>
						{
							status === 'pending'?
							<span>
								Processing Payment
								<Spinner className="ml-1" animation="border" size="sm"/>
							</span>
							:
							`Pay ${String.fromCharCode(acceptedCurrency.char_code)}${total} (${acceptedCurrency.ISO})`
						}
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default PurchaseModal